import { IConfiguration } from "@app/config/getConfig.interfaces";
import ProductionConfig from "@app/config/production";

const DevelopmentConfig: Omit<IConfiguration, "supportedBrackets"> = {
  ...ProductionConfig,
  environment: "development",
  version: "development",
  mapsToken: "AIzaSyBzQhUbdz-sLAFBmj5LjxTJy5jkpuUnmHE",
  urls: {
    requestQuote:
      "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-requestQuote",
    systemLoads:
      "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-systemLoads",
    estimateProduction:
      "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-estimateProduction",
    webshopOrder:
      "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-webshopOrder",
    electricalDesign:
      "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1_electricalDesign",
    submitLead:
      "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-lead-submitLead",
    app: "https://rauli.turator.fi",
    token: "http://127.0.0.1:5001/raulibrackets/europe-west1/v1-token",
    admin: {
      users:
        "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-admin-fetchUsers",
      prices:
        "http://127.0.0.1:5001/demo-raulibrackets/europe-west1/v1-admin-updatePrices",
    },
  },
  useEmulators:
    typeof window !== "undefined" &&
    window.location &&
    ["127.0.0.1", "localhost"].includes(window.location.hostname)
      ? true
      : false,
};

if (!DevelopmentConfig.useEmulators) {
  DevelopmentConfig.firebase.projectId = "raulibrackets";
  DevelopmentConfig.urls.requestQuote =
    "https://europe-west1-raulibrackets.cloudfunctions.net/v1-requestQuote";
  DevelopmentConfig.urls.systemLoads =
    "https://europe-west1-raulibrackets.cloudfunctions.net/v1-systemLoads";
  DevelopmentConfig.urls.token =
    "https://europe-west1-raulibrackets.cloudfunctions.net/v1-token";
  DevelopmentConfig.urls.admin.users =
    "https://europe-west1-raulibrackets.cloudfunctions.net/v1-admin-fetchUsers";
  DevelopmentConfig.urls.admin.prices =
    "https://europe-west1-raulibrackets.cloudfunctions.net/v1-admin-updatePrices";
}

export default DevelopmentConfig;
